import { IProjectDetail } from '@/widgets/Comment/models';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { styleTooltip } from '@/components/app-tooltip/AppTooltip';

import useFetch from '@hooks/useFetch';

import { API } from '@utils/constants/Apis';
import { DataViewer } from '@utils/helpers/common';

type Props = {
  project?: Pick<
    IProjectDetail,
    'picName' | 'applicantName' | 'projectApplicant' | 'applicantCountryName' | 'visaCategoryName' | 'location' | 'nonVisaApplicationRequire'
  >;
  className?: string;
  showMOT?: boolean;
  numTrunk?: number;
};
export const ProjectDetailPreviewInfo = (props: Props) => {
  const { project: projectPropData, className, showMOT, numTrunk } = props;
  const { t } = useTranslation();
  const { id, idProject } = useParams();
  const projectId = id || idProject || '';
  const { data: projectApiData } = useFetch<IProjectDetail>(API.GET_PROJECT_DETAIL(projectId), 'GET', undefined, undefined, {
    autoFetch: !projectPropData && !!projectId
  });

  const project = projectPropData ?? projectApiData;

  if (!project) {
    return null;
  }

  const listInfo = [
    {
      label: t('project_detail:mot_pick:label'),
      value: project?.picName,
      hide: !showMOT
    },
    {
      label: t('project_detail:application'),
      value: project?.applicantName,
      hide: project?.nonVisaApplicationRequire
    },
    {
      label: t('project:fields:company_name'),
      value: project?.projectApplicant?.currentCompany
    },
    {
      label: t('project_detail:country_of_application'),
      value: project?.applicantCountryName
    },
    {
      label: t('project_detail:category'),
      value: project?.visaCategoryName
    },
    {
      label: t('project_detail:location'),
      value: project?.location
    }
  ];

  const numTrunkLine = numTrunk || listInfo?.length;

  const renderInfo = (data: any) => (
    <div className={classNames('flex justify-end gap-x-[16px] gap-y-1 min-w-0', className)}>
      {data.map((item: any) => {
        if (item.hide) {
          return null;
        }
        return (
          <div key={item.label} className='flex min-w-0'>
            <span className='shrink-0'>{item.label}：</span>

            <Tooltip title={item.value} {...styleTooltip}>
              <span className={classNames('truncate font-bold min-w-0 max-w-[400px]', item.valueClassName)}>{DataViewer.display(item.value)}</span>
            </Tooltip>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className='w-full'>
      {renderInfo(listInfo.slice(0, numTrunkLine))}
      {renderInfo(listInfo.slice(numTrunkLine))}
    </div>
  );
};
